module.exports = __webpack_public_path__ + "static/media/dropdown-arrow-white.ad4bcf19.svg";